import { apiClient } from './api-client'
import { API_ENDPOINTS } from '@/config/constants'
import { ClientLog, BackOfficeLog, PaginatedLogsResponse } from '@/types'

export interface FilterCondition {
  type: string
  value: unknown
}

export interface LogsQueryParams {
  page?: number
  limit?: number
  sort?: string
  sortDirection?: -1 | 1
  filter?: Record<string, FilterCondition>
}

export const activityLogsService = {
  getClientLogs: async (params: LogsQueryParams = {}): Promise<PaginatedLogsResponse<ClientLog>> => {
    const { page = 0, limit = 20, sort, sortDirection, filter } = params
    
    // Build request body
    const body: LogsQueryParams = {
      page,
      limit,
    }
    
    if (sort) {
      body.sort = sort
    }
    if (sortDirection !== undefined) {
      body.sortDirection = sortDirection
    }
    if (filter && Object.keys(filter).length > 0) {
      body.filter = filter
    }
    
    const url = `${API_ENDPOINTS.LOGS.BY_SOURCE('CLIENT')}/paginated`
    return apiClient.post<PaginatedLogsResponse<ClientLog>>(url, body)
  },
  getBackOfficeLogs: async (params: LogsQueryParams = {}): Promise<PaginatedLogsResponse<BackOfficeLog>> => {
    const { page = 0, limit = 20, sort, sortDirection, filter } = params
    
    // Build request body
    const body: LogsQueryParams = {
      page,
      limit,
    }
    
    if (sort) {
      body.sort = sort
    }
    if (sortDirection !== undefined) {
      body.sortDirection = sortDirection
    }
    if (filter && Object.keys(filter).length > 0) {
      body.filter = filter
    }
    
    const url = `${API_ENDPOINTS.LOGS.BY_SOURCE('BO')}/paginated`
    return apiClient.post<PaginatedLogsResponse<BackOfficeLog>>(url, body)
  },
}
